module.exports = __webpack_public_path__ + "img/feature_buy_th.5c252267.png";